import React from 'react';
import Btn, { ButtonRefType } from '../Btn';
import { BtnModifier } from '../Btn';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { SharedButtonProps } from './SharedButtonProps';

type ButtonActionConfirmSpecificProps = {
  text: string;
  type?: 'button' | 'submit' | 'reset';
  href?: string;
  routing?: boolean;
  reference?: ButtonRefType;
  focusOnMount?: boolean;
  tooltipPlacement?: TooltipPlacement;
  children?: React.ReactNode;
};

export type ButtonActionConfirmProps = SharedButtonProps & ButtonActionConfirmSpecificProps;

export function ButtonActionConfirm({
  text,
  onClick,
  disabled,
  ariaDisabled,
  type = ariaDisabled ? 'button' : 'submit',
  ariaLabel,
  ariaDescribedBy,
  href,
  routing,
  reference,
  focusOnMount,
  children,
  ...rest
}: ButtonActionConfirmProps) {
  return (
    <Btn
      {...rest}
      modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_YES]}
      text={text}
      onClick={onClick}
      disabled={disabled}
      ariaDisabled={ariaDisabled}
      type={type}
      ariaLabel={ariaLabel}
      ariaDescribedBy={ariaDescribedBy}
      href={href}
      routing={routing}
      reference={reference}
      focusOnMount={focusOnMount}
    >
      {children}
    </Btn>
  );
}
